
import { SET_TEAMRANKINGS } from "../actions/action_teamrankings";
import { SET_TEAMRANKINGS_SHOWLOADER } from "../actions/action_teamrankings";
import { SET_TEAMRANKINGS_DATA } from "../actions/action_teamrankings";
import { SET_TEAMRANKINGS_CHARTREGISTERED } from "../actions/action_teamrankings";

const data = {
        labels: [],
        datasets: [{
            label: "Rank",
            backgroundColor: 'rgb(6, 190, 189)',
            borderColor: 'rgb(6, 190, 189)',
            data: [],
            lineTension: 0,
            fill: false,
        }]
    };

const initialState = {
  rankings: [],
  trdata: data,
  showLoader: false,
  chartRegistered: false
}

export default function (state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_TEAMRANKINGS:
      var updatedData = state.trdata;
      updatedData.labels = action.payload.labels;
      updatedData.datasets[0].data = action.payload.ranks;
      newState = {
        rankings: action.payload,
        data : updatedData,
        showLoader: false,
        chartRegistered: true
      }
      return { ...state, ...newState };
    case SET_TEAMRANKINGS_SHOWLOADER:
      return { ...state, showLoader: action.payload };
    case SET_TEAMRANKINGS_DATA:
      return { ...state, trdata: action.payload };
    case SET_TEAMRANKINGS_CHARTREGISTERED:
      return { ...state, chartRegistered: action.payload };
    default:
      return state;
  }
}
